import { iterate, empty, singleton, append, map, collect, delay, toList } from "../../../fable_modules/fable-library.3.7.9/Seq.js";
import { indexed as indexed_1, tryFind, contains } from "../../../fable_modules/fable-library.3.7.9/Array.js";
import { comparePrimitives, createObj, equals, stringHash } from "../../../fable_modules/fable-library.3.7.9/Util.js";
import { QueryProperty, MinMax, Query_get_Default, Query_OfCqp_Z680882E9, MainCategory, Subcategory, AttrOperator_OfString_Z721C83C5, AttrOperator } from "../../Model/CwbExtended.js";
import { createElement } from "react";
import { LoadedCorpus_Msg } from "../../Update.js";
import { Interop_reactApi } from "../../../fable_modules/Feliz.1.64.0/Interop.fs.js";
import { Helpers_extractClasses, Helpers_combineClasses } from "../../../fable_modules/Feliz.Bulma.2.18.0/ElementBuilders.fs.js";
import { SharedCorpusInfo__TryGetAttribute_Z721C83C5, SharedCorpusInfo__HasAttribute_Z721C83C5 } from "../../../Shared/Shared.js";
import { Corpus__get_CwbAttributeMenu, Corpus__get_SharedInfo } from "../../Model/Model.js";
import { append as append_1, indexed, choose, tryFind as tryFind_1, collect as collect_1, cons, zip, tryPick, ofArray, singleton as singleton_1, isEmpty, mapIndexed, empty as empty_1 } from "../../../fable_modules/fable-library.3.7.9/List.js";
import { exists, toList as toList_1, FSharpSet__Add, FSharpSet__Remove, FSharpSet__Contains, empty as empty_2, toArray } from "../../../fable_modules/fable-library.3.7.9/Set.js";
import { join, replace } from "../../../fable_modules/fable-library.3.7.9/String.js";
import { useReact_useEffectOnce_3A5B6456, useReact_useElementRef } from "../../../fable_modules/Feliz.1.64.0/React.fs.js";
import { map as map_1, defaultArg, toArray as toArray_1 } from "../../../fable_modules/fable-library.3.7.9/Option.js";
import { PropHelpers_createOnKey } from "../../../fable_modules/Feliz.1.64.0/Properties.fs.js";
import { key_enter } from "../../../fable_modules/Feliz.1.64.0/Key.fs.js";
import { FSharpRef, toString } from "../../../fable_modules/fable-library.3.7.9/Types.js";
import { tryParse } from "../../../fable_modules/fable-library.3.7.9/Int32.js";

export function includeExcludeTags(query, queryIndex, term, termIndex, dispatch) {
    return toList(delay(() => collect((forms) => {
        const attrStr = contains(forms.Attr, ["lemma", "phon", "orig"], {
            Equals: (x, y) => (x === y),
            GetHashCode: stringHash,
        }) ? (`${forms.Attr}:`) : "";
        return toList(delay(() => map((value_1) => {
            const props_2 = toList(delay(() => append(equals(forms.Operator, new AttrOperator(1)) ? singleton(["className", "is-danger"]) : singleton(["className", "is-info"]), delay(() => {
                let elems, value_6;
                return singleton((elems = [(value_6 = (`${attrStr}${value_1}`), createElement("span", {
                    children: [value_6],
                })), createElement("button", {
                    onClick: (_arg1) => {
                        dispatch(new LoadedCorpus_Msg(11, query, queryIndex, term, termIndex, forms.Attr));
                    },
                    className: "delete is-small",
                })], ["children", Interop_reactApi.Children.toArray(Array.from(elems))]));
            }))));
            return createElement("span", createObj(Helpers_combineClasses("tag", props_2)));
        }, forms.Values)));
    }, term.ExtraForms)));
}

export function AttributeModal(attributeModalInputProps) {
    let elms_11, elms_7, props_34, elms_8, patternInput_1, elems_16, elms_10, elms_9, elems_26, elm_8, children_24, children_27, elms_12, elems_30, props_64, elems_29, props_62, elems_28;
    const dispatch = attributeModalInputProps.dispatch;
    const termIndex = attributeModalInputProps.termIndex;
    const term = attributeModalInputProps.term;
    const query = attributeModalInputProps.query;
    const modalModel = attributeModalInputProps.modalModel;
    const corpus = attributeModalInputProps.corpus;
    let includeExcludeOptions;
    const hasLemma = SharedCorpusInfo__HasAttribute_Z721C83C5(Corpus__get_SharedInfo(corpus), "lemma");
    const hasPhon = SharedCorpusInfo__HasAttribute_Z721C83C5(Corpus__get_SharedInfo(corpus), "phon");
    const hasOrig = SharedCorpusInfo__HasAttribute_Z721C83C5(Corpus__get_SharedInfo(corpus), "orig");
    const wordName = hasOrig ? "corrected" : "word";
    includeExcludeOptions = toList(delay(() => append(singleton(createElement("option", {
        value: "default",
        children: "Specify/exclude",
    })), delay(() => append(singleton(createElement("option", {
        value: "specify_word",
        children: `Specify ${wordName} form`,
    })), delay(() => append(hasLemma ? singleton(createElement("option", {
        value: "specify_lemma",
        children: "Specify lemma",
    })) : empty(), delay(() => append(hasPhon ? singleton(createElement("option", {
        value: "specify_phon",
        children: "Specify phonetic form",
    })) : empty(), delay(() => append(hasOrig ? singleton(createElement("option", {
        value: "specify_orig",
        children: "Specify original form",
    })) : empty(), delay(() => append(singleton(createElement("option", {
        value: "exclude_word",
        children: `Exclude ${wordName} form`,
    })), delay(() => append(hasLemma ? singleton(createElement("option", {
        value: "exclude_lemma",
        children: "Exclude lemma",
    })) : empty(), delay(() => append(hasPhon ? singleton(createElement("option", {
        value: "exclude_phon",
        children: "Exclude phonetic form",
    })) : empty(), delay(() => (hasOrig ? singleton(createElement("option", {
        value: "exclude_orig",
        children: "Exclude original form",
    })) : empty())))))))))))))))))));
    let attrMenu;
    const matchValue_5 = Corpus__get_CwbAttributeMenu(corpus);
    attrMenu = ((matchValue_5 == null) ? empty_1() : mapIndexed((sectionIndex_2, tupledArg) => {
        const menuSection = tupledArg[0];
        const termSectionSelection_1 = tupledArg[1];
        const subcategoryPanels = toList(delay(() => collect((matchValue_6) => {
            let _arg3, cat_1, heading_1, props_26, elems_10, elms_4, children_12, selectedMainCategory, children_9, elms_3;
            const subcategories_1 = matchValue_6[3];
            return isEmpty(subcategories_1) ? singleton(null) : singleton((_arg3 = tryFind((cat) => {
                if ((cat.Attr === matchValue_6[0].Code) && (cat.Value === matchValue_6[1])) {
                    return !equals(cat.Operator, new AttrOperator(1));
                }
                else {
                    return false;
                }
            }, toArray(termSectionSelection_1)), (_arg3 == null) ? null : ((cat_1 = _arg3, (heading_1 = replace(menuSection.SubcategoryHeading, "@category", matchValue_6[2]), (props_26 = ofArray([["className", "is-info"], (elems_10 = [(elms_4 = singleton_1(createElement("p", {
                children: [heading_1],
            })), createElement("div", {
                className: "message-header",
                children: Interop_reactApi.Children.toArray(Array.from(elms_4)),
            })), (children_12 = singleton_1((selectedMainCategory = cat_1, (children_9 = singleton_1((elms_3 = toList(delay(() => collect((matchValue_4) => {
                let elm_2, elms_2, children_1, props_5, children_4, elms_1;
                return singleton((elm_2 = [(elms_2 = ofArray([(children_1 = singleton_1((props_5 = ofArray([["className", "is-6"], ["children", matchValue_4[0] + ":"]]), createElement("h1", createObj(Helpers_combineClasses("title", props_5))))), createElement("div", {
                    className: "level-item",
                    children: Interop_reactApi.Children.toArray(Array.from(children_1)),
                })), (children_4 = singleton_1((elms_1 = toList(delay(() => collect((matchValue_2) => {
                    let subCategory, attrWithoutValues, matchValue_3, _arg2, isSelected_1, props_3;
                    const attrValue_1 = matchValue_2[1];
                    const attr_1 = matchValue_2[0];
                    return singleton((subCategory = ((attrWithoutValues = (new Subcategory(attr_1.Code, AttrOperator_OfString_Z721C83C5("="), empty_2({
                        Compare: comparePrimitives,
                    }))), (matchValue_3 = selectedMainCategory.Subcategories, (matchValue_3 == null) ? attrWithoutValues : ((_arg2 = tryFind((subcat) => (subcat.Attr === attr_1.Code), toArray(matchValue_3)), (_arg2 == null) ? attrWithoutValues : _arg2))))), (isSelected_1 = FSharpSet__Contains(subCategory.Values, attrValue_1), (props_3 = toList(delay(() => append(isSelected_1 ? singleton(["className", "is-success"]) : empty(), delay(() => append(singleton(["onClick", (_arg1_1) => {
                        dispatch(new LoadedCorpus_Msg(13, query, modalModel.QueryIndex, term, termIndex, sectionIndex_2, selectedMainCategory, isSelected_1 ? (new Subcategory(subCategory.Attr, subCategory.Operator, FSharpSet__Remove(subCategory.Values, attrValue_1))) : (new Subcategory(subCategory.Attr, subCategory.Operator, FSharpSet__Add(subCategory.Values, attrValue_1)))));
                    }]), delay(() => singleton(["children", matchValue_2[2]]))))))), createElement("button", createObj(Helpers_combineClasses("button", props_3)))))));
                }, matchValue_4[1]))), createElement("div", {
                    className: "buttons",
                    children: Interop_reactApi.Children.toArray(Array.from(elms_1)),
                }))), createElement("div", {
                    className: "level-item",
                    children: Interop_reactApi.Children.toArray(Array.from(children_4)),
                }))]), createElement("div", {
                    className: "level-left",
                    children: Interop_reactApi.Children.toArray(Array.from(elms_2)),
                }))], createElement("nav", {
                    className: "level",
                    children: Interop_reactApi.Children.toArray(Array.from(elm_2)),
                })));
            }, subcategories_1))), createElement("div", {
                className: "column",
                children: Interop_reactApi.Children.toArray(Array.from(elms_3)),
            }))), createElement("div", {
                className: "columns",
                children: Interop_reactApi.Children.toArray(Array.from(children_9)),
            })))), createElement("div", {
                className: "message-body",
                children: Interop_reactApi.Children.toArray(Array.from(children_12)),
            }))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_10))])]), createElement("article", createObj(Helpers_combineClasses("message", props_26)))))))));
        }, menuSection.Values)));
        const children_16 = toList(delay(() => {
            let props_31, elems_13, elms_5, elms_6, elms;
            return append(singleton((props_31 = ofArray([["className", "is-info"], (elems_13 = [(elms_5 = singleton_1(createElement("p", {
                children: [menuSection.Heading],
            })), createElement("div", {
                className: "message-header",
                children: Interop_reactApi.Children.toArray(Array.from(elms_5)),
            })), (elms_6 = singleton_1((elms = toList(delay(() => collect((matchValue) => {
                let patternInput, _arg1, props;
                const attrValue = matchValue[1];
                const attr = matchValue[0];
                return singleton((patternInput = ((_arg1 = tryPick((selectedMainCat) => {
                    if ((selectedMainCat.Attr === attr.Code) && (selectedMainCat.Value === attrValue)) {
                        return equals(selectedMainCat.Operator, new AttrOperator(1));
                    }
                    else {
                        return void 0;
                    }
                }, toList_1(termSectionSelection_1)), (_arg1 == null) ? [false, false] : [true, _arg1])), (props = toList(delay(() => append(patternInput[1] ? singleton(["className", "is-danger"]) : (patternInput[0] ? singleton(["className", "is-success"]) : empty()), delay(() => append(singleton(["onClick", (e) => {
                    let matchValue_1;
                    dispatch(new LoadedCorpus_Msg(12, query, modalModel.QueryIndex, term, termIndex, sectionIndex_2, new MainCategory(attr.Code, (matchValue_1 = [e.altKey, attr.Code], matchValue_1[0] ? ((matchValue_1[1] === "descr") ? (new AttrOperator(3)) : (new AttrOperator(1))) : ((matchValue_1[1] === "descr") ? (new AttrOperator(2)) : (new AttrOperator(0)))), attrValue, void 0)));
                }]), delay(() => singleton(["children", matchValue[2]]))))))), createElement("button", createObj(Helpers_combineClasses("button", props))))));
            }, menuSection.Values))), createElement("div", {
                className: "buttons",
                children: Interop_reactApi.Children.toArray(Array.from(elms)),
            }))), createElement("div", {
                className: "message-body",
                children: Interop_reactApi.Children.toArray(Array.from(elms_6)),
            }))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_13))])]), createElement("article", createObj(Helpers_combineClasses("message", props_31))))), delay(() => subcategoryPanels));
        }));
        return createElement("span", {
            children: Interop_reactApi.Children.toArray(Array.from(children_16)),
        });
    }, zip(matchValue_5, term.CategorySections)));
    const elementRef = useReact_useElementRef();
    useReact_useEffectOnce_3A5B6456(() => {
        iterate((modalElement) => {
            modalElement.focus();
        }, toArray_1(elementRef.current));
    });
    let includeExcludeControls;
    const elm_5 = [(elms_11 = ofArray([(elms_7 = singleton_1((props_34 = ofArray([["style", {
        width: 200,
    }], ["value", modalModel.IncludeExcludeInput], ["onChange", (ev) => {
        dispatch(new LoadedCorpus_Msg(9, ev.target.value));
    }]]), createElement("input", createObj(cons(["type", "text"], Helpers_combineClasses("input", props_34)))))), createElement("div", {
        className: "level-item",
        children: Interop_reactApi.Children.toArray(Array.from(elms_7)),
    })), (elms_8 = singleton_1((patternInput_1 = Helpers_extractClasses(ofArray([["disabled", modalModel.IncludeExcludeInput === ""], ["value", "default"], ["onChange", (ev_1) => {
        dispatch(new LoadedCorpus_Msg(10, query, modalModel.QueryIndex, term, termIndex, ev_1.target.value));
    }], ["children", Interop_reactApi.Children.toArray(Array.from(includeExcludeOptions))]])), createElement("div", createObj(ofArray([["className", join(" ", cons("select", patternInput_1[0]))], (elems_16 = [createElement("select", createObj(patternInput_1[1]))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_16))])]))))), createElement("div", {
        className: "level-item",
        children: Interop_reactApi.Children.toArray(Array.from(elms_8)),
    })), (elms_10 = singleton_1((elms_9 = includeExcludeTags(query, 0, term, termIndex, dispatch), createElement("div", {
        className: "tags",
        children: Interop_reactApi.Children.toArray(Array.from(elms_9)),
    }))), createElement("div", {
        className: "level-item",
        children: Interop_reactApi.Children.toArray(Array.from(elms_10)),
    }))]), createElement("div", {
        className: "level-left",
        children: Interop_reactApi.Children.toArray(Array.from(elms_11)),
    }))];
    includeExcludeControls = createElement("nav", {
        className: "level",
        children: Interop_reactApi.Children.toArray(Array.from(elm_5)),
    });
    let footer;
    const props_57 = ofArray([["style", {
        display: "block",
    }], (elems_26 = [(elm_8 = [(children_24 = singleton_1(createElement("div", createObj(Helpers_combineClasses("level-item", singleton_1(["children", "Click to select; alt/option + click to exclude"]))))), createElement("div", {
        className: "level-left",
        children: Interop_reactApi.Children.toArray(Array.from(children_24)),
    })), (children_27 = singleton_1((elms_12 = ofArray([createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-danger"], ["onClick", (_arg2_1) => {
        dispatch(new LoadedCorpus_Msg(14, query, modalModel.QueryIndex, term, termIndex));
    }], ["children", "Clear"]])))), createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-success"], ["onClick", (_arg3_1) => {
        dispatch(new LoadedCorpus_Msg(21));
    }], ["children", "Search"]])))), createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-info"], ["onClick", (_arg4) => {
        dispatch(new LoadedCorpus_Msg(18, void 0));
    }], ["children", "Close"]]))))]), createElement("div", {
        className: "level-item",
        children: Interop_reactApi.Children.toArray(Array.from(elms_12)),
    }))), createElement("div", {
        className: "level-right",
        children: Interop_reactApi.Children.toArray(Array.from(children_27)),
    }))], createElement("nav", {
        className: "level",
        children: Interop_reactApi.Children.toArray(Array.from(elm_8)),
    }))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_26))])]);
    footer = createElement("footer", createObj(Helpers_combineClasses("modal-card-foot", props_57)));
    const props_68 = ofArray([["className", "is-active"], ["ref", elementRef], ["tabIndex", 0], ["onKeyUp", (e_1) => {
        if (e_1.key === "Escape") {
            dispatch(new LoadedCorpus_Msg(18, void 0));
        }
    }], (elems_30 = [createElement("div", createObj(Helpers_combineClasses("modal-background", singleton_1(["onClick", (_arg5) => {
        dispatch(new LoadedCorpus_Msg(18, void 0));
    }])))), (props_64 = ofArray([["style", {
        width: 900,
    }], (elems_29 = [(props_62 = ofArray([["style", {
        width: 900,
    }], (elems_28 = [createElement("div", {
        className: "box",
        children: Interop_reactApi.Children.toArray(Array.from(attrMenu)),
    }), includeExcludeControls], ["children", Interop_reactApi.Children.toArray(Array.from(elems_28))])]), createElement("section", createObj(Helpers_combineClasses("modal-card-body", props_62)))), footer], ["children", Interop_reactApi.Children.toArray(Array.from(elems_29))])]), createElement("div", createObj(Helpers_combineClasses("modal-card", props_64)))), createElement("button", createObj(Helpers_combineClasses("modal-close", ofArray([["className", "is-large"], ["onClick", (_arg6) => {
        dispatch(new LoadedCorpus_Msg(18, void 0));
    }]]))))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_30))])]);
    return createElement("div", createObj(Helpers_combineClasses("modal", props_68)));
}

export function view(corpus, search, underlyingQuery, queryIndex, maybeAttrModalModel, dispatch) {
    let elems_24;
    const query = (search.Params.Queries.length > 0) ? Query_OfCqp_Z680882E9(corpus, underlyingQuery.QueryString) : Query_get_Default();
    let segmentType;
    const matchValue = Corpus__get_SharedInfo(corpus).Modality;
    segmentType = ((matchValue.tag === 1) ? "Sentence" : "Segment");
    const props_47 = ofArray([["style", {
        marginBottom: 15,
    }], (elems_24 = toList(delay(() => append(toList(delay(() => collect((matchValue_10) => {
        let term, termIndex, mainStringInput, props_3, checkbox, removeTermButton, props_11, elems_3, elms, attributeTags, matchValue_6;
        return (term = matchValue_10[1], (termIndex = (matchValue_10[0] | 0), (mainStringInput = ((props_3 = ofArray([["value", defaultArg(term.MainStringValue, "")], ["onKeyUp", (ev_1) => {
            PropHelpers_createOnKey(key_enter, (_arg1) => {
                dispatch(new LoadedCorpus_Msg(21));
            }, ev_1);
        }], ["onChange", (ev_2) => {
            const s_1 = ev_2.target.value;
            dispatch(new LoadedCorpus_Msg(7, query, queryIndex, term, termIndex, (s_1 === "") ? (void 0) : s_1));
        }], ["style", {
            width: 108,
        }]]), createElement("input", createObj(cons(["type", "text"], Helpers_combineClasses("input", props_3)))))), (checkbox = ((label, title, isChecked, property) => {
            let elems_1, s_2;
            return createElement("label", createObj(ofArray([["title", title], ["style", {
                marginRight: 15,
            }], (elems_1 = [createElement("input", createObj(cons(["type", "checkbox"], Helpers_combineClasses("checkbox", ofArray([["checked", isChecked], ["onChange", (ev_3) => {
                dispatch(new LoadedCorpus_Msg(8, query, queryIndex, term, termIndex, property, ev_3.target.checked));
            }]]))))), (s_2 = (` ${label}`), createElement("span", {
                className: "",
                children: s_2,
            }))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_1))])])));
        }), (removeTermButton = ((props_11 = ofArray([["title", "Remove search word"], ["onClick", (_arg2) => {
            dispatch(new LoadedCorpus_Msg(17, query, queryIndex, termIndex));
        }], (elems_3 = [(elms = singleton_1(createElement("i", {
            className: "fas fa-minus",
        })), createElement("span", {
            className: "icon",
            children: Interop_reactApi.Children.toArray(Array.from(elms)),
        }))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_3))])]), createElement("button", createObj(Helpers_combineClasses("button", props_11))))), (attributeTags = ((matchValue_6 = Corpus__get_CwbAttributeMenu(corpus), (matchValue_6 == null) ? empty_1() : collect_1((tupledArg) => {
            const _arg4 = tupledArg[1];
            return toList(delay(() => collect((matchValue_7) => {
                let _arg1_1, selectedMainCat_1, subcatStr, props_15;
                return singleton((_arg1_1 = tryFind_1((selectedCat) => {
                    if (selectedCat.Attr === matchValue_7[0].Code) {
                        return selectedCat.Value === matchValue_7[1];
                    }
                    else {
                        return false;
                    }
                }, toList_1(_arg4[1])), (_arg1_1 == null) ? null : ((selectedMainCat_1 = _arg1_1, (subcatStr = join(" ", toList(delay(() => collect((matchValue_3) => singleton(join(" or ", choose((x) => x, toList(delay(() => collect((matchValue_4) => {
                    const matchValue_5 = selectedMainCat_1.Subcategories;
                    return (matchValue_5 == null) ? singleton(void 0) : (exists((selectedSubcat) => {
                        if (selectedSubcat.Attr === matchValue_4[0].Code) {
                            return FSharpSet__Contains(selectedSubcat.Values, matchValue_4[1]);
                        }
                        else {
                            return false;
                        }
                    }, matchValue_5) ? singleton(matchValue_4[2]) : empty());
                }, matchValue_3[1])))))), matchValue_7[3])))), (props_15 = toList(delay(() => append(equals(selectedMainCat_1.Operator, new AttrOperator(1)) ? singleton(["className", "is-danger"]) : singleton(["className", "is-info"]), delay(() => {
                    let elems_4, value_54;
                    return singleton((elems_4 = [(value_54 = (`${matchValue_7[2]} ${subcatStr}`), createElement("span", {
                        children: [value_54],
                    })), createElement("button", {
                        className: "delete is-small",
                        onClick: (_arg3) => {
                            dispatch(new LoadedCorpus_Msg(12, query, queryIndex, term, termIndex, tupledArg[0], selectedMainCat_1));
                        },
                    })], ["children", Interop_reactApi.Children.toArray(Array.from(elems_4))]));
                })))), createElement("span", createObj(Helpers_combineClasses("tag", props_15)))))))));
            }, _arg4[0].Values)));
        }, indexed(zip(matchValue_6, term.CategorySections))))), toList(delay(() => {
            let am, am_1;
            return append((maybeAttrModalModel != null) ? (((am = maybeAttrModalModel, (am.QueryIndex === queryIndex) && (am.TermIndex === termIndex))) ? ((am_1 = maybeAttrModalModel, singleton(createElement(AttributeModal, {
                corpus: corpus,
                modalModel: am_1,
                query: query,
                term: term,
                termIndex: termIndex,
                dispatch: dispatch,
            })))) : ((empty()))) : ((empty())), delay(() => {
                let minMaxField, elms_1;
                return append((termIndex > 0) ? ((minMaxField = ((minMax_1) => {
                    let elems_6, minMax, children, props, matchValue_1, interval, valueStr, children_3, s_3;
                    const props_19 = ofArray([["className", "is-grouped"], ["className", "is-align-items-center"], (elems_6 = [(minMax = minMax_1, (children = singleton_1((props = ofArray([["className", "has-text-right"], ["style", {
                        width: 38,
                    }], ["value", (matchValue_1 = term.PrecedingInterval, (matchValue_1 == null) ? "" : ((interval = matchValue_1, (valueStr = ((value_5) => defaultArg(map_1(toString, value_5), "")), (minMax.tag === 1) ? valueStr(interval.Max) : valueStr(interval.Min)))))], ["onChange", (ev) => {
                        const s = ev.target.value;
                        if (s === "") {
                            dispatch(new LoadedCorpus_Msg(15, query, queryIndex, term, termIndex, minMax, void 0));
                        }
                        let matchValue_2;
                        let outArg = 0;
                        matchValue_2 = [tryParse(s, 511, false, 32, new FSharpRef(() => outArg, (v) => {
                            outArg = (v | 0);
                        })), outArg];
                        if (matchValue_2[0]) {
                            dispatch(new LoadedCorpus_Msg(15, query, queryIndex, term, termIndex, minMax, matchValue_2[1]));
                        }
                    }]]), createElement("input", createObj(cons(["type", "text"], Helpers_combineClasses("input", props)))))), createElement("div", {
                        className: "control",
                        children: Interop_reactApi.Children.toArray(Array.from(children)),
                    }))), (children_3 = singleton_1((s_3 = ((minMax_1.tag === 1) ? "max" : "min"), createElement("div", {
                        className: "",
                        children: s_3,
                    }))), createElement("div", {
                        className: "control",
                        children: Interop_reactApi.Children.toArray(Array.from(children_3)),
                    }))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_6))])]);
                    return createElement("div", createObj(Helpers_combineClasses("field", props_19)));
                }), singleton((elms_1 = ofArray([minMaxField(new MinMax(0)), minMaxField(new MinMax(1))]), createElement("div", {
                    className: "column",
                    children: Interop_reactApi.Children.toArray(Array.from(elms_1)),
                }))))) : empty(), delay(() => {
                    let elms_4, props_29, props_31, elems_14, props_34, elems_16, elms_3;
                    return singleton((elms_4 = ofArray([(props_29 = toList(delay(() => append(singleton(["className", "has-addons"]), delay(() => append((query.Terms.length > 1) ? singleton(["className", "has-addons-right"]) : empty(), delay(() => {
                        let elems_13;
                        return singleton((elems_13 = toList(delay(() => {
                            let children_7, props_24, elems_9, elms_2;
                            return append(singleton((children_7 = singleton_1((props_24 = ofArray([["onClick", (_arg5) => {
                                dispatch(new LoadedCorpus_Msg(18, [queryIndex, termIndex]));
                            }], (elems_9 = [(elms_2 = singleton_1(createElement("i", {
                                className: "fas fa-list",
                            })), createElement("span", {
                                className: "icon",
                                children: Interop_reactApi.Children.toArray(Array.from(elms_2)),
                            }))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_9))])]), createElement("button", createObj(Helpers_combineClasses("button", props_24))))), createElement("div", {
                                className: "control",
                                children: Interop_reactApi.Children.toArray(Array.from(children_7)),
                            }))), delay(() => append(singleton(createElement("div", {
                                className: "control",
                                children: Interop_reactApi.Children.toArray([mainStringInput]),
                            })), delay(() => ((query.Terms.length > 1) ? singleton(createElement("div", {
                                className: "control",
                                children: Interop_reactApi.Children.toArray([removeTermButton]),
                            })) : empty())))));
                        })), ["children", Interop_reactApi.Children.toArray(Array.from(elems_13))]));
                    })))))), createElement("div", createObj(Helpers_combineClasses("field", props_29)))), (props_31 = ofArray([["className", "is-grouped"], ["className", "is-grouped-multiline"], (elems_14 = toList(delay(() => append(SharedCorpusInfo__HasAttribute_Z721C83C5(Corpus__get_SharedInfo(corpus), "lemma") ? singleton(checkbox("Lemma", "Lemma", term.IsLemma, new QueryProperty(0))) : empty(), delay(() => append(singleton(checkbox("Start", "Start of word", term.IsStart, new QueryProperty(3))), delay(() => append(singleton(checkbox("End", "End of word", term.IsEnd, new QueryProperty(4))), delay(() => append(singleton(checkbox("Middle", "Middle of word", term.IsMiddle, new QueryProperty(5))), delay(() => {
                        let matchValue_8, attr;
                        return append((matchValue_8 = SharedCorpusInfo__TryGetAttribute_Z721C83C5(Corpus__get_SharedInfo(corpus), "phon"), (matchValue_8 == null) ? ((empty())) : ((attr = matchValue_8, singleton(checkbox(attr.Name, attr.Name, term.IsPhonetic, new QueryProperty(1)))))), delay(() => append(SharedCorpusInfo__HasAttribute_Z721C83C5(Corpus__get_SharedInfo(corpus), "orig") ? singleton(checkbox("Original", "Original form", term.IsOriginal, new QueryProperty(2))) : empty(), delay(() => append((termIndex === 0) ? singleton(checkbox(`${segmentType} initial`, `${segmentType} initial`, term.IsInitial, new QueryProperty(6))) : empty(), delay(() => {
                            if (termIndex === (query.Terms.length - 1)) {
                                const matchValue_9 = Corpus__get_SharedInfo(corpus).Modality;
                                return (matchValue_9.tag === 1) ? singleton(null) : singleton(checkbox(`${segmentType} final`, `${segmentType} final`, term.IsFinal, new QueryProperty(7)));
                            }
                            else {
                                return empty();
                            }
                        }))))));
                    })))))))))), ["children", Interop_reactApi.Children.toArray(Array.from(elems_14))])]), createElement("div", createObj(Helpers_combineClasses("field", props_31)))), (props_34 = ofArray([["style", {
                        marginTop: 10,
                    }], (elems_16 = [(elms_3 = append_1(attributeTags, includeExcludeTags(query, 0, term, termIndex, dispatch)), createElement("div", {
                        className: "tags",
                        children: Interop_reactApi.Children.toArray(Array.from(elms_3)),
                    }))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_16))])]), createElement("div", createObj(Helpers_combineClasses("field", props_34))))]), createElement("div", {
                        className: "column",
                        children: Interop_reactApi.Children.toArray(Array.from(elms_4)),
                    })));
                }));
            }));
        }))))))));
    }, indexed_1(query.Terms)))), delay(() => {
        let children_18, elms_7;
        return singleton((children_18 = singleton_1((elms_7 = toList(delay(() => {
            let props_39, elems_19, elms_5;
            return append(singleton((props_39 = ofArray([["className", "is-info"], ["title", "Add search word"], ["onClick", (_arg6) => {
                dispatch(new LoadedCorpus_Msg(16, query, queryIndex));
            }], (elems_19 = [(elms_5 = singleton_1(createElement("i", {
                className: "fas fa-plus",
            })), createElement("span", {
                className: "icon",
                children: Interop_reactApi.Children.toArray(Array.from(elms_5)),
            }))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_19))])]), createElement("button", createObj(Helpers_combineClasses("button", props_39))))), delay(() => {
                let props_43, elems_21, elms_6;
                return (search.Params.Queries.length > 1) ? singleton((props_43 = ofArray([["className", "is-danger"], ["title", "Delete row"], ["onClick", (_arg7) => {
                    dispatch(new LoadedCorpus_Msg(6, queryIndex));
                }], (elems_21 = [(elms_6 = singleton_1(createElement("i", {
                    className: join(" ", ["fa fa-times"]),
                })), createElement("span", {
                    className: "icon",
                    children: Interop_reactApi.Children.toArray(Array.from(elms_6)),
                }))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_21))])]), createElement("button", createObj(Helpers_combineClasses("button", props_43))))) : empty();
            }));
        })), createElement("div", {
            className: "buttons",
            children: Interop_reactApi.Children.toArray(Array.from(elms_7)),
        }))), createElement("div", {
            className: "column",
            children: Interop_reactApi.Children.toArray(Array.from(children_18)),
        })));
    })))), ["children", Interop_reactApi.Children.toArray(Array.from(elems_24))])]);
    return createElement("div", createObj(Helpers_combineClasses("columns", props_47)));
}

